// ===========================================
// Account Settings - Constants
// ===========================================

/**
 * Brand colors for fun mode cards
 */
export const CARD_COLORS = {
  header: { border: '#FFAE9E', bg: 'rgba(255, 174, 158, 0.12)' }, // Coral
  profile: { border: '#4580E4', bg: 'rgba(69, 128, 228, 0.08)' }, // Blue
  avatar: { border: '#A855F7', bg: 'rgba(168, 85, 247, 0.08)' }, // Purple
  password: { border: '#FFCE00', bg: 'rgba(255, 206, 0, 0.12)' }, // Yellow
  export: { border: '#96DAC9', bg: 'rgba(150, 218, 201, 0.15)' }, // Mint
  delete: { border: '#FFB6C1', bg: 'rgba(255, 182, 193, 0.12)' }, // Pink (Alice)
  twoFactor: { border: '#10B981', bg: 'rgba(16, 185, 129, 0.08)' }, // Emerald green
};

/**
 * Default profile form data
 */
export const DEFAULT_PROFILE_FORM = {
  firstName: '',
  lastName: '',
  phone: '',
};

/**
 * Default password form data
 */
export const DEFAULT_PASSWORD_FORM = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
};

/**
 * Default snackbar state
 */
export const DEFAULT_SNACKBAR_STATE = {
  open: false,
  message: '',
  severity: 'success' as const,
};
